import React, { useMemo } from 'react';
import { ApiClient } from '../../api';
import DashBoard from '../../components/dashboard';
import { useQuery } from 'react-query';
import { useRootStatistics } from '../../utils/hooks/useRootStatistics';
import { getDashboardWithdrawalStatisticsView } from '../../utils/rootStatistics';

const DashBoardContainer = () => {
    const rootStatistics = useRootStatistics();
    const { data: rawWithdrawalsData } = useQuery('withdrawals', ApiClient.getWithdrawalStats);
    const withdrawalsData = useMemo(
        () => getDashboardWithdrawalStatisticsView(rawWithdrawalsData, rootStatistics),
        [rawWithdrawalsData, rootStatistics],
    );

    return <DashBoard withdrawalsData={withdrawalsData} />;
};

export default DashBoardContainer;
